import { Box, SxProps, Typography, useTheme } from '@mui/material';

import { FormattedMessage, useIntl } from 'react-intl';
import { pxToRem } from '@/theme/typography';
import ImageBoxFuture from '@/components/shared/image-box-future';

export const EmptyState = (): JSX.Element => {
  const theme = useTheme();
  const intl = useIntl();
  const popoverSx: SxProps = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: pxToRem(24),
    height: '100%',
  };
  return (
    <Box sx={popoverSx}>
      <ImageBoxFuture
        img='/icons/notifications/empty-notification-icon.svg'
        title={intl.formatMessage({
          id: 'alt.empty_notification_icon',
        })}
        objectFit='contain'
        sx={{
          marginBottom: {
            mobile: '30px',
            tablet: pxToRem(30),
          },
          width: { mobile: '168px', tablet: pxToRem(168) },
          height: { mobile: '118px', tablet: pxToRem(118) },
        }}
      />
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: {
            mobile: '16px',
            tablet: pxToRem(16),
          },
          color: theme.palette.grey[60],
          textAlign: 'center',
          lineHeight: '24px',
          inlineSize: {
            mobile: '316px',
            tablet: pxToRem(316),
          },
        }}
      >
        <FormattedMessage id='notifications.empty.state' />
      </Typography>
    </Box>
  );
};
